import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import ActorCard from '@/components/base/ActorCard';
import { actors } from '@/mocks/actors';

const regionFilters = ['全部', '中国大陆', '韩国', '日本', '欧美'];

export default function Actors() {
  const [region, setRegion] = useState('全部');
  const [initial, setInitial] = useState('全部');

  const initials = useMemo(() => {
    const set = new Set(actors.map((a) => a.initial));
    return Array.from(set).sort();
  }, []);

  const filtered = useMemo(
    () =>
      actors.filter((a) => {
        const regionMatch = region === '全部' || a.region === region;
        const initialMatch = initial === '全部' || a.initial === initial;
        return regionMatch && initialMatch;
      }),
    [region, initial],
  );

  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-8 py-8 md:py-12">
        <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-5">
          <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
          <i className="ri-arrow-right-s-line" />
          <span className="text-foreground-300">演员资料</span>
        </nav>

        <div className="mb-8">
          <h1 className="text-2xl md:text-4xl font-bold text-foreground-50 font-heading">演员索引</h1>
          <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-400 leading-relaxed">
            汇集参演成人短剧的优秀演员，按地区与姓名首字母快速查找，点击可查看详细资料与关联作品。
          </p>
        </div>

        <div className="flex flex-col gap-5 mb-8">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs font-semibold text-foreground-500 mr-1">地区</span>
            {regionFilters.map((r) => (
              <button
                key={r}
                type="button"
                onClick={() => setRegion(r)}
                className={`rounded-full px-4 py-1.5 text-xs transition-colors cursor-pointer whitespace-nowrap ${
                  region === r ? 'bg-primary-600 text-background-50' : 'bg-background-900 text-foreground-300 hover:bg-background-800'
                }`}
              >
                {r}
              </button>
            ))}
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs font-semibold text-foreground-500 mr-1">首字母</span>
            {['全部', ...initials].map((letter) => (
              <button
                key={letter}
                type="button"
                onClick={() => setInitial(letter)}
                className={`flex h-8 min-w-8 items-center justify-center rounded-md px-3 text-xs transition-colors cursor-pointer ${
                  initial === letter ? 'bg-accent-600 text-background-50' : 'bg-background-900 text-foreground-300 hover:bg-background-800'
                }`}
              >
                {letter}
              </button>
            ))}
          </div>
        </div>

        {filtered.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
            {filtered.map((actor) => (
              <ActorCard key={actor.id} actor={actor} />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-700 bg-background-900/40 py-20">
            <i className="ri-user-search-line text-5xl text-foreground-600" />
            <p className="mt-4 text-foreground-300">暂无演员资料</p>
            <button
              type="button"
              onClick={() => { setRegion('全部'); setInitial('全部'); }}
              className="mt-5 rounded-md bg-primary-600 px-5 py-2 text-sm font-medium text-background-50 hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              重置筛选
            </button>
          </div>
        )}
      </div>
    </SiteLayout>
  );
}